import { ILoadHistoryEventResponse } from '../../../../interfaces/ILoadHistoryResponse';
import LoadHistoryUtils from '../../utils/load-history-drawer.utils';

function HistoryItemSentToPool({
    history,
}: Readonly<{
    history: ILoadHistoryEventResponse;
}>) {
    return (
        <div
            key={history.eventDate.toString()}
            className="load-history-event-container load-history-line"
            data-testid="load-history-event-sent-to-pool"
        >
            <div className="load-history-section-title">
                <h4 className="load-history-event-type">
                    {LoadHistoryUtils.getEventLabel(history)}
                </h4>
            </div>
            <span>
                {LoadHistoryUtils.getDateTimeLabel(
                    history.metadata.roundStartDate ?? history.eventDate,
                )}
            </span>
            <span>Carga adicionada ao Pool</span>
        </div>
    );
}

export default HistoryItemSentToPool;
